import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useForm } from 'react-hook-form';
import cleanDeep from "clean-deep";
import { Actions as LEAVEACTIONS } from '../../../../store/actions/leaveActions';
import Select from 'react-select';

const options = [
    {
        label: "All leaves",
        value: 2
    },
    {
        label: "Vacation leave only",
        value: 1
    },
    {
        label: "None",
        value: 0
    }
];

const TimeAndAttendance = ({
    existingCompanyDetails,
    updateCompanyDetails,
    prevPage,
    updateSetting,
    getLeaveTypes,
    leaveTypes
}) => {

    useEffect(() => {
        if (!leaveTypes) getLeaveTypes()
    }, []);

    const { org, enableTimesheets, employeeViewTimesheets, employeeInputTimesheets, selectedLeaveOption } = existingCompanyDetails;

    const [selectedSetting, setSelectedSetting] = useState(options.find(option => option.value == selectedLeaveOption) || options[1]);


    const { handleSubmit } = useForm();

    const onSubmit = () => {
        const leaveSettings = leaveTypes && leaveTypes.filter(leave => leave.organisation == 0).map((leave) => ({
            id: leave.id,
            name: leave.name,
            employeeCanApply: (selectedSetting.value == 2) || (selectedSetting.value == 1 && leave.id == 6020),
            showBalance: leave.id == 6020,
            applyIfBalanceAvailable: (selectedSetting.value == 2) || (selectedSetting.value == 1 && leave.id == 6020)
        }));
        updateCompanyDetails(cleanDeep({ org: org, enableTimesheets, employeeViewTimesheets, employeeInputTimesheets, leaveSettings }, { emptyStrings: false, emptyArrays: false, emptyObjects: false }));
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-xs-12 form-section" style={{ paddingBottom: '2rem'}}>
                <div className='col-xs-12'>
                    <div className='col-xs-6 pl-0'>
                        <h4>Time & Attendance</h4>
                    </div>
                </div>
                <div className='col-xs-12'>

                    <label className="css-input switch switch-sm switch-success">
                        <input type="checkbox" name="enableTimesheets" checked={enableTimesheets} onChange={(e) => updateSetting(e.target.name, e.target.checked)} />
                        <span />Enable timesheets
                    </label>
                    <label className="css-input switch switch-sm switch-success">
                        <input type="checkbox" name="employeeViewTimesheets" checked={employeeViewTimesheets} onChange={(e) => updateSetting(e.target.name, e.target.checked)} />
                        <span />Allow employees to view timesheets
                    </label>
                    <label className="css-input switch switch-sm switch-success">
                        <input type="checkbox" name="employeeInputTimesheets" checked={employeeInputTimesheets} onChange={(e) => updateSetting(e.target.name, e.target.checked)} />
                        <span />Allow employees to manually input timesheets
                    </label>
                    <label>
                        Which leave types should employees be able to apply for?
                    </label>
                    <Select
                        options={options}
                        value={selectedSetting}
                        onChange={(e) => {
                            updateSetting("selectedLeaveOption", e.value)
                            setSelectedSetting(e)
                        }}
                    />
                </div>
                <div className="clearfix" />
            </div>
            <div style={{ marginTop: 10 }}>
                <a href="#" className="btn btn-default" onClick={prevPage}>Back</a>
                <button className="btn btn-success right" type="submit">
                    Save
                </button>
            </div>
        </form>
    )
};

const mapStateToProps = (state) => {
    return {
        leaveTypes: state.leave.leaveTypes,
        existingCompanyDetails: state.company.newCompany
    }
};

const mapDispatchToProps = (dispatch) => ({
    getLeaveTypes: () => dispatch(LEAVEACTIONS.getLeaveTypes())
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeAndAttendance);